import createIcon from '../../createIcon';

/**
 * @component @name Newspaper
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgM0wyMC4zMyA0LjY3TDE4LjY3IDNMMTcgNC42N0wxNS4zMyAzTDEzLjY3IDQuNjdMMTIgM0wxMC4zMyA0LjY3TDguNjcgM0w3IDQuNjdMNS4zMyAzTDMuNjcgNC42N0wyIDNWMTlDMiAyMC4xIDIuOSAyMSA0IDIxSDIwQzIxLjEgMjEgMjIgMjAuMSAyMiAxOVYzWk0xMSAxOUg0VjEzSDExVjE5Wk0yMCAxOUgxM1YxN0gyMFYxOVpNMjAgMTVIMTNWMTNIMjBWMTVaTTIwIDExSDRWOEgyMFYxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Newspaper = createIcon('Newspaper', [
  [
    'path',
    {
      d: 'M22 3L20.33 4.67L18.67 3L17 4.67L15.33 3L13.67 4.67L12 3L10.33 4.67L8.67 3L7 4.67L5.33 3L3.67 4.67L2 3V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V3ZM11 19H4V13H11V19ZM20 19H13V17H20V19ZM20 15H13V13H20V15ZM20 11H4V8H20V11Z',
      key: '18m8hz',
    },
  ],
]);

export default Newspaper;
